import {
  put, takeLatest,
} from 'redux-saga/effects';
import { MainMenuItems } from '~/mainMenu/mainMenuItem.enum';
import { openLeftSidebarApp } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';
import { openNewModal } from '~/store/modal/modal.actionCreators';

export function* leftSidebarSagas() {
  yield takeLatest(openLeftSidebarApp.type, openToolboxlessLeftMenuTool);
}

function* openToolboxlessLeftMenuTool(
  action: ReturnType<typeof openLeftSidebarApp>,
) {
  const { app } = action.payload;

  if (app === MainMenuItems.ShareMap) {
    yield handleShareMapMenuItemOpen();
  }
}

function* handleShareMapMenuItemOpen() {
  yield put(openNewModal('ShareMapSelect', undefined));
}
